module.exports = __webpack_public_path__ + "img/st-lucia.78602fd9.svg";